
import { computed, defineComponent, ref } from "vue";
import { useStore } from "@/store";
import AgCard from "@/components/ag-card/index.vue";
import EventInspection from "@/helpers/pages/EventInspection";
import api from "@/store/axiosAgsc";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { useRoute } from "vue-router";
import moment from "moment";
const store = useStore();
import EventBus from "@/helpers/EventBus";
import { Roles } from "@/helpers/enums/Roles";
import dateOptions from "@/helpers/DateOptions";
import router from "./../../../router";

export default defineComponent({
  name: "EventInspection",
  components: { AgCard },
  data() {
    return {
      emptyEventFilters: ["all-events", "SummaryEvents"], //list of url params for empty eventTypeKeyword filter
      dateOptions: dateOptions,
      eventTypes: [],
      tempData: {
        total: 0,
        rows: [],
      },
      pdfHeaders: [
        "computerGuid",
        "computerName",
        "evenId",
        "eventType",
        "facility",
        "facilityName",
        "hash",
        "policyVersion",
        "processPath",
        "reportEventDate",
        "severity",
        "type",
        "typeName",
      ],
    };
  },
  setup() {
    let module = ref(EventInspection);
    // const store = useStore();
    const setFilterStatus = () => {
      store.dispatch(GeneralActionTypes.FILTER_STATUS, false);
    };
    const route = useRoute();

    const user: any = computed(() => store.getters.loggedInUser);
    const group: any = computed(() => store.getters.group);
    const filterInit = {
      page: 1,
      limit: 10,
      startDate: moment().utc().startOf("day").subtract(7, "days"),
      endDate: moment().utc(),
      eventTypeKeyword: "",
      severity: "",
      os: null,
      code: null,
      commandLine: "",
      policyFileVersion: null,
      count: null,
      membershipType: null,
      type: null,
      agentVersion: "",
      user: "",
      groupIds: "",
      computer: "",
      policyDownloadDate: "",
      truncated: null,
      isElevated: null,
      integrityLevel: null,
      isImpersonating: null,
    };
    let filter: any = ref(filterInit);
    const RESETFILTER = filter;
    const getList = (
      filters: any = filter.value,
      options: any = module.value.component.options
    ) => {
      const body = { filters, options };
      if (!body.filters.startDate) {
        body.filters.startDate = filterInit.startDate;
      }
      if (!body.filters.endDate) {
        body.filters.endDate = filterInit.endDate;
      }

      delete filters.range;
      store.dispatch(GeneralActionTypes.GET_EVENTS, body);
    };

    const searchWithFilters = (param: any) => {
      module.value.filter.filters.forEach((element) => {
        if (element.requestKey) {
          if (element.requestKey == "computer") {
            element.requestKey = "computerGuid";
          }

          if (element.requestKey == "mode" && element.vmodel == "Enforcing") {
            filter.value[element.requestKey] = 1;
          } else if (
            element.requestKey == "mode" &&
            element.vmodel == "Discovery"
          ) {
            filter.value[element.requestKey] = 2;
          } else if (element.requestKey == "access") {
            filter.value[element.requestKey] = element.vmodel
              ? element.vmodel.toLowerCase()
              : "";
          } else if (element.vmodel == "All") {
            filter.value[element.requestKey] = "";
          } else if (element.vmodel == "all") {
            filter.value[element.requestKey] = "";
          } else {
            filter.value[element.requestKey] = element.vmodel;
          }
         
          if (["truncated", "isElevated", "isImpersonating"].includes(element.requestKey)) {
            if (filter.value[element.requestKey] === '' || filter.value[element.requestKey] === undefined) {
              filter.value[element.requestKey] = null;
            }
          }
        }
      });

      filter.value.endDate = moment().utc();
      filter.value.startDate = moment().utc().startOf("day").subtract(7, "days");

      if (!param) {
        const findDate: any = module.value.filter.filters.find(
          (f) => f.param == "range"
        );
        if (findDate && findDate.vmodel) {
          if (
            typeof findDate.vmodel === "object" &&
            findDate.vmodel.start &&
            findDate.vmodel.end
          ) {
            filter.value.endDate = findDate.vmodel.end;
            filter.value.startDate = findDate.vmodel.start;
          } else {
            filter.value.startDate = findDate.vmodel;
          }
        }
      }

      filter.value.agscEventType =
        route.params.param === "SummaryEvents" ? 1 : 0;

      const filters = filter.value;
      delete filters.computer;
      const options = module.value.component.options;
      options.page = 1;
      module.value.readyToUseFilters = filters;
      if (!param) {
        router.push({ query: { searchResults: "true" } });
      }
      getList(filters, options);
    };

    const resetFilters = (type: any) => {
      module.value.filter.filters.forEach((item: any) => {
        if (item.param == "range") {
          item.vmodel = dateOptions[2].value;
          item.selectedLabel = dateOptions[2].label;
        } else {
          item.vmodel = null;
        }
      });

      searchWithFilters(true);
      if (type != "init") {
        let query = Object.assign({}, router.currentRoute.value.query);
        delete query.searchResults;
        router.replace({ query });
      }
    };

    return {
      setFilterStatus,
      searchWithFilters,
      resetFilters,
      filter,
      getList,
      module,
    };
  },
  mounted() {
    EventBus.on("eventInspectionLoad", (data: any) => {
      this.loadFilters(data);
      const filters = this.filter;
      this.module.readyToUseFilters = filters;
      const options = this.module.component.options;
      this.getList(filters, options);
      return;
    });
    this.resetFilters("init");
  },
  methods: {
    mainLink(data: any) {
      if(data && data === 'onSearch') {
        this.searchWithFilters(false);
        return;
      }
      if (this.tempData.total > 0) {
        this.module.component.options.rows = this.tempData.rows;
        this.module.component.options.total = this.tempData.total;
      } else {
        this.resetFilters("init");
      }
    },
    search() {
      this.tempData.rows = this.module.component.options.rows;
      this.tempData.total = this.module.component.options.total;
      this.module.component.options.rows = [];
      this.module.component.options.total = 0;
    },
    loadFiltersIfExist() {
      this.module.filter.filters.forEach((item) => {
        item.vmodel = null;
      });
      let data: any = this.$route.params.data;
      if (data != undefined) {
        data = JSON.parse(data);
        data.forEach((item: any) => {
          this.filter[item.name] = item.value;
          this.module.filter.filters.forEach((filter: any) => {
            if (filter.apiEquivalent === "range") {
              if (!filter.vmodel) {
                this.filter["startDate"] = moment().utc().startOf("day").subtract(7, "days");
                this.filter["endDate"] = moment().utc();
              }

              if (this.filter.range)
                this.module.filter.filters[10] = this.filter.range;
              return;
            }
            if (filter.apiEquivalent == item.name) {
              filter.selectedLabel = item.selectedLabel;
              filter.vmodel = item.value;
              return;
            }
          });
        });
      }
    },
    loadFilters(data: any) {
      this.module.filter.filters.forEach((item) => {
        item.vmodel = null;
      });
      if (data != undefined) {
        data = JSON.parse(data);
        console.log(data);
        data.forEach((item: any) => {
          this.filter[item.name] = item.value;
          this.module.filter.filters.forEach((filter) => {
            if (filter.apiEquivalent === "range" && item.name === "range") {
              if (!filter.vmodel) {
                this.filter["startDate"] = item.value.vmodel.start;
                this.filter["endDate"] = item.value.vmodel.end;
              } else {
                this.filter["startDate"] = moment().utc().startOf("day").subtract(7, "days");
                this.filter["endDate"] = moment().utc();
              }

              if (this.filter.range) {
                this.module.filter.filters[10] = this.filter.range;
              }
              return;
            }
            if (filter.apiEquivalent == item.name) {
              filter.selectedLabel = item.selectedLabel;
              filter.vmodel = item.value;
              return;
            } else if (item.name !== "range") {
              if(item.name == 'groupIds') {
                item.name = 'companySiteGroup'
              }
              const filterIndex = this.module.filter.filters.findIndex(
                (i) => i && i.type && i.type == item.name
              );
              let filterData: any = {
                requestKey: item.name,
                selectType: item.name,
                selectedLabel: item.selectedLabel,
                title: item.name,
                type: item.name,
                hidden: true,
                vmodel: item.value,
              };
              if (item.name == "groupIds") {
                filterData = {
                  vmodel: item.value,
                  title: "companySiteGroup",
                  selectedLabel: item.selectedLabel,
                  key: "groupIds",
                  hidden: true,
                  type: "companySiteGroup",
                  requestKey: "groupIds",
                  apiEquivalent: "groupIds",
                };
              }
              if (item.name == "Site") {
                filterData = {
                  hidden: true,
                  key: "SiteGuid",
                  requestKey: "SiteGuid",
                  selectedLabel: item.selectedLabel,
                  title: "Site",
                  type: "Site",
                  vmodel: item.value,
                };
              }

              if (filterIndex === -1) {
                this.module.filter.filters.push(filterData);
                this.filter[item.name] = item.value;
              } else {
                this.module.filter.filters[filterIndex] = filterData;
              }
            }
          });
        });

        this.module.filter.filters.forEach((element) => {
          if (element.requestKey) {
            if (element.requestKey == "computer") {
              element.requestKey = "computerGuid";
            }

            if (element.requestKey == "mode" && element.vmodel == "Enforcing") {
              this.filter[element.requestKey] = 1;
            } else if (
              element.requestKey == "mode" &&
              element.vmodel == "Discovery"
            ) {
              this.filter[element.requestKey] = 2;
            } else if (element.requestKey == "access") {
              this.filter[element.requestKey] = element.vmodel
                ? element.vmodel.toLowerCase()
                : "";
            } else if (element.vmodel == "All") {
              this.filter[element.requestKey] = "";
            } else if (element.vmodel == "all") {
              this.filter[element.requestKey] = "";
            } else {
              this.filter[element.requestKey] = element.vmodel;
            }
          }
        });

        console.log(this.module.filter.filters);
      }
    },
  },
});
